function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.032,0,0,0.032,0,3)",
    stroke: "none",
    style: {
      fill: "#95a5a6"
    },
    d: "M 480 286 L 217 409 L 84 372 L 0 409 L 155 510 L 125 681 L 221 631 L 253 530 L 542 409 L 562 757 L 649 709 L 723 331 C 723 331 805 297 867 265 C 928 233 1000 187 977 144 C 956 102 886 106 838 128 C 790 151 677 196 677 196 L 327 0 L 258 38 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneIcon);
export default __webpack_public_path__ + "static/media/plane-icon.b1696d5cff1feea9b626b76bbba277ae.svg";
export { ForwardRef as ReactComponent };